import React from 'react';
import { Anchor, Text } from '@common-fe/common-fe';
import styled from 'styled-components';
const Link = styled(Anchor)``;
export interface Props {
  onClick: () => void;
  testId?: string;
}
const PlaceholderBaseLink: React.FC<Props> = ({ onClick, testId = 'placeholder-base' }) => {
  return (
    <Text data-testid={`${testId}_text`} size="large" margin={{ top: 'spacing24' }} weight={700}>
      Please select an{' '}
      <Link data-testid={`${testId}_link`} onClick={onClick}>
        employer
      </Link>{' '}
      to view the relevant data and insights
    </Text>
  );
};

export default PlaceholderBaseLink;
